import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import FragorSvarOmApiSakerhet from "./sections/FragorSvarOmApiSakerhet";
import KontaktaOss from "./sections/KontaktaOss";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Introduction />
      <FragorSvarOmApiSakerhet />
      <KontaktaOss />
      <Footer />
    </div>;
}